import React from 'react'
import { Formik, FormikHelpers, Form } from 'formik'
import { AdminApi } from '../admin.api'
import { useDispatch } from 'react-redux'
import { AdminActions } from '../admin.store'
import { useNavigate } from 'react-router-dom'
import { RoutesEnum } from '../../routes.constants'
import { CreateStandRequest } from '../admin.interfaces'
import PublicStandFeatures from '../components/public-stand-features.component'
// import ManagementSection from "../components/management-section.component";
import FixedPageTitle from '../components/fixed-page-title.component'
// import { CostsSection } from "../components/costs-section.component";
import { createStandSchema } from '../validation.schemas'
import { Container } from '../../shared/shared.styled'
import PrimaryButton from '../../shared/components/button.component'
import { useAlert } from 'react-alert'
import { useModal } from 'react-modal-hook'
import { ConfirmationModal } from '../../shared/components/modals/confirmation.modal'
import { Company } from '../../shared/shared.models'

export interface IBaseInterface {
    company: Company
}

interface CompanyPageProps {
    companyId: string
}

const CreateStandPage = ({ companyId }: CompanyPageProps) => {
    // Hooks Initialization
    const dispatch = useDispatch()
    const navigate = useNavigate()
    //const isSuperAdmin = useIsSuperAdmin()
    const alert = useAlert()

    const [showConfirmationModal, hideConfirmationModal] = useModal(
        () => (
            <ConfirmationModal
                title="Tem a certeza que quer sair"
                description="Vai perder toda a informação que modificou"
                onClick={() => {
                    hideConfirmationModal()
                    window.history.back()
                }}
                onCancel={hideConfirmationModal}
            />
        ),
        []
    )

    /**
     * Helper function to get the initial formikValues
     * @param stand Stand | undefined
     */
    const getFormikInitialValues = () => {
        return {
            name: '',
            location: '',
            address: undefined,
            companyUuid: companyId,
        }
    }

    /**
     * Calls the API endpoint to save a stand, and handles the loading/error states
     * of the form
     * @param values CreateStandRequest
     * @param actions FormikHelpers<CreateStandRequest>
     */
    const addStand = async (
        values: CreateStandRequest,
        actions: FormikHelpers<CreateStandRequest>
    ) => {
        try {
            actions.setSubmitting(true)
            const res = await AdminApi.methods.createStand(values)
            dispatch(
                AdminActions.methods.createStandSuccessAction(res.data.stand)
            )
            navigate(
                RoutesEnum.COMPANY_PAGE.replace(
                    ':companyId',
                    values.companyUuid
                )
            )
        } catch (e) {
            alert.error('Erro ao criar o stand. Por favor tente mais tarde')
        }
    }

    const checkIfFormIsDirtyAndClose = (isDirty: boolean) => {
        if (isDirty) {
            showConfirmationModal()
        } else {
            window.history.back()
        }
    }

    const renderButtons = (isSubmitting: boolean, isDirty: boolean) => (
        <>
            <PrimaryButton
                label="Cancelar"
                onClick={() => checkIfFormIsDirtyAndClose(isDirty)}
            />
            <PrimaryButton
                isLoading={isSubmitting}
                type="submit"
                label="Criar stand"
                redTheme={true}
            />
        </>
    )

    return (
        <Container>
            <Formik<CreateStandRequest>
                onSubmit={addStand}
                initialValues={getFormikInitialValues()}
                validateOnChange={false}
                validationSchema={createStandSchema()}
                enableReinitialize={true}
            >
                {({ isSubmitting, handleSubmit, dirty }) => (
                    <Form
                        translate="yes"
                        onSubmit={isSubmitting ? () => null : handleSubmit}
                    >
                        <FixedPageTitle
                            label="Criar um novo stand"
                            rightButtons={renderButtons(isSubmitting, dirty)}
                        />

                        <PublicStandFeatures isEditing={true} />
                        {/* {vehicle && <MediaSection vehicleId={vehicle.uuid} />} */}
                    </Form>
                )}
            </Formik>
        </Container>
    )
}

export default CreateStandPage
